import {custom, JSONObject, optional, required} from 'ts-json-object'


export class BaseResponseObject extends JSONObject {
    public cached_dom: JQuery = null;

    public domCacheLookUp(getter: () => JQuery): JQuery {
        if (this.cached_dom === null)
            return this.cached_dom = getter();
        return this.cached_dom;
    }
}

export class B64File extends BaseResponseObject {
    @required
    @custom((_, __, value) => {
        const bytes = atob(value.toString());
        const raw = new Array(bytes.length);
        for (let i = 0; i < bytes.length; i++)
            raw[i] = bytes.charCodeAt(i);
        return new Uint8Array(raw);
    })
    b64: Uint8Array

    @required
    file_name: string

    @required
    mime_type: string
}

export class EmptyResponse extends BaseResponseObject {
}

export class RetryAfterErrorData extends BaseResponseObject {
    @required
    public readonly retry_after: Date
}

export interface ApiError<T = {}> {
    message: string,
    code: number,
    data: T
}

export interface BaseResponse<ResultT extends BaseResponseObject | BaseResponseObject[] = EmptyResponse,
    ErrT extends ApiError = ApiError> {
    success: boolean,
    error: ErrT,
    result: ResultT
}

export interface GenericPayload {
    [x: string]: unknown;
}

export type RequestOptions = {
    show_loading: boolean,
    default_eh: boolean,
    fail_handle_session_handle: boolean,
    loading_image: string
}

export enum SupportedPaymentMethods {
    NEXY = 'nexy',
    PAYPAL = 'paypal',
}

export class FAQS extends BaseResponseObject {
    @required
    public readonly question: string;

    @required
    public readonly answer: string;

    @required
    public readonly last_edit_date: Date;
}

export class GetFine extends BaseResponseObject {
    @required
    public readonly name: string;
    @required
    public readonly address: string;
    @optional
    public readonly car_rental: string | null;
    @optional
    public readonly license_plate: string | null;
    @optional
    public readonly violation_date: Date | null;
    @optional
    public readonly violation_time: Date | null;
    @required
    public readonly violation: string;
    @required
    public readonly violation_location: string;
    @required
    public readonly description: string;
    @optional
    public readonly attachment_1: string | null;
    @optional
    public readonly attachment_2: string | null;
    @required
    public readonly iban: string;
    @required
    public readonly fine_amount: number;
    @required
    public readonly verbal_id: string
    @required
    public readonly smartprise_id: number;
    @required
    public readonly online_payment: boolean
    @optional
    public readonly attribute_5: string | null;
}

export class Fines extends BaseResponseObject {
    @required
    public readonly smartprise_id: number;
    @required
    public readonly shipping_date: Date; //Date al momento metti stringa
    @required
    public readonly fine_amount: Number;
    @required
    public readonly verbal_id: string
    @required
    public readonly protocol_year: string;
    @required
    public readonly letter_no: string;
    @required
    public readonly customer_name: string;
}

export class Ticket extends BaseResponseObject {
    @required
    public readonly title: string;
    @required
    public readonly body: string;
    @required
    public readonly link: string;
    @required
    public readonly number: number;
}

export type inputGetUpdates = {
    print_id: number,
    updates_no: number
}[];

export function getDefaultRequestOptions(overwriting: Partial<RequestOptions> = {}): RequestOptions {
    const rt = {
        show_loading: true,
        default_eh: true,
        fail_handle_session_handle: true,
        loading_image: "ui/resources/static/loading.gif"
    }

    Object.assign(rt, overwriting);

    return rt;
}

